import lazyPage from '@monorepo/deprecated/core/hoc/lazyPage'

export default () => ({
  path: '/',
  // component: lazyPage(() => import('../../containers/Home')),
  component: lazyPage(() => import('App/View/Home').then(({ Home }) => Home)),
  exact: true,
})
